/*
 * Live-updates the PDP free-shipping bar when the cart changes.
 *
 * The bar is server-rendered correct on load (snippets/free-shipping.liquid).
 * On the theme's `cart-update` pub/sub event (published by product-form.js on
 * add-to-cart), we refetch /cart.js for the authoritative total and recompute
 * progress + message client-side, reusing the translated <template>s so we
 * don't reimplement i18n. The threshold + money format come from data attrs.
 */
(function () {
  function cartJsUrl() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + 'cart.js';
  }

  function formatMoney(cents, format) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format);
    }
    return (cents / 100).toFixed(2);
  }

  function whenPubSubReady(cb, tries) {
    tries = tries || 0;
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      cb();
    } else if (tries < 40) { // give up after ~2s; the bar still renders correctly on load
      setTimeout(function () { whenPubSubReady(cb, tries + 1); }, 50);
    }
  }

  var FreeShippingBar = function () {};

  function define() {
    if (customElements.get('free-shipping-bar')) return;

    customElements.define(
      'free-shipping-bar',
      class extends HTMLElement {
        connectedCallback() {
          this.threshold = parseInt(this.dataset.threshold, 10) || 0;
          this.moneyFormat = this.dataset.moneyFormat || '';
          var self = this;
          whenPubSubReady(function () {
            self._unsub = subscribe(PUB_SUB_EVENTS.cartUpdate, self.onCartUpdate.bind(self));
          });
        }

        disconnectedCallback() {
          if (this._unsub) this._unsub();
        }

        onCartUpdate() {
          var self = this;
          fetch(cartJsUrl())
            .then(function (r) { return r.json(); })
            .then(function (cart) { self.render(cart.total_price); })
            .catch(function () {});
        }

        render(total) {
          if (!this.threshold) return;
          var bar = this.querySelector('[data-fs-bar] .free-shipping');
          if (!bar) return;
          var textEl = bar.querySelector('.free-shipping__text');
          var progEl = bar.querySelector('.free-shipping__progress');
          if (!textEl || !progEl) return;

          if (total >= this.threshold) {
            var successTpl = this.querySelector('template[data-fs-success]');
            textEl.innerHTML = successTpl ? successTpl.innerHTML.trim() : textEl.innerHTML;
            textEl.classList.add('free-shipping__text--success');
            progEl.classList.add('free-shipping__progress--success');
            progEl.style.setProperty('--progress', '100%');
          } else {
            var remaining = this.threshold - total;
            var remTpl = this.querySelector('template[data-fs-remaining]');
            if (remTpl) {
              textEl.innerHTML = remTpl.innerHTML.trim().replace(
                '__AMOUNT__',
                '<span class="ship-price">' + formatMoney(remaining, this.moneyFormat) + '</span>'
              );
            }
            textEl.classList.remove('free-shipping__text--success');
            progEl.classList.remove('free-shipping__progress--success');
            var pct = Math.round(Math.min(total / this.threshold, 1) * 100);
            progEl.style.setProperty('--progress', pct + '%');
          }
        }
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', define);
  } else {
    define();
  }
})();
